import {
  cx,
  Modal,
  ModalButton,
  ModalContent,
  ModalDismiss,
  ModalFooter,
  ModalHeader,
  ModalProps,
  ModalTitle,
  Text,
} from '@vtex/admin-ui'
import { useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { styles } from './styles'

const CANCEL_VARIANT_MAP = {
  primary: 'secondary',
  secondary: 'tertiary',
  critical: 'neutralTertiary',
} as const

const CONFIRM_VARIANT_MAP = {
  primary: 'primary',
  secondary: 'primary',
  critical: 'critical',
} as const

type MessageType = {
  id: string
}

type Props = {
  state: ModalProps['state']
  onConfirm: () => void
  onCancel: () => void
  variant?: 'primary' | 'secondary' | 'critical'
  messages: {
    title: MessageType
    description: MessageType
    subtitle: MessageType
    cancel: MessageType
    continue: MessageType
  }
  className?: string
}

export function ConfirmationModal(props: Props) {
  const {
    state,
    onConfirm,
    onCancel,
    variant = 'primary',
    messages,
    className,
  } = props

  const confirmed = useRef<boolean>(false)

  const wasOpen = useRef<boolean>(false)

  useEffect(() => {
    if (!state.open && wasOpen.current) {
      if (confirmed.current) {
        onConfirm()
        confirmed.current = false
      } else {
        onCancel()
      }
    }
    wasOpen.current = state.open
  }, [onCancel, onConfirm, state.open])

  const cancelVariant = CANCEL_VARIANT_MAP[variant] || 'secondary'
  const confirmVariant = CONFIRM_VARIANT_MAP[variant] || 'primary'

  return (
    <Modal state={state} className={cx(styles.modal, className ?? '')}>
      <ModalHeader className={styles.modalHeader}>
        <ModalTitle className={styles.confirmationTitle}>
          <FormattedMessage {...messages.title} />
        </ModalTitle>
        <ModalDismiss />
      </ModalHeader>
      <ModalContent>
        <FormattedMessage
          values={{
            b: (content) => <Text variant="action1">{content}</Text>,
            enter: () => <br />,
          }}
          {...messages.description}
        />
        <br />
        <br />
        <FormattedMessage {...messages.subtitle} />
      </ModalContent>
      <ModalFooter className={styles.modalFooter}>
        <ModalButton
          className={styles.fullWidth}
          dismissModal
          variant={cancelVariant}
          size="large"
        >
          <FormattedMessage {...messages.cancel} />
        </ModalButton>
        <ModalButton
          onClick={() => {
            confirmed.current = true
          }}
          dismissModal
          size="large"
          className={styles.fullWidth}
          variant={confirmVariant}
        >
          <FormattedMessage {...messages.continue} />
        </ModalButton>
      </ModalFooter>
    </Modal>
  )
}
